<script setup lang="ts">
const route = useRoute()
</script>

<template>
  <div class="relative w-screen h-screen flex flex-col lg:flex-row items-center justify-center">
    <div class="flex flex-col w-full lg:w-2/3 min-h-[calc(100%-104px)] h-full lg:p-8 bg-gray-50">
      <div class="justify-between items-center flex w-full pb-8 pt-2 lg:pt-0 pr-4 lg:pr-0">
        <NuxtLink to="/" :replace="route.name === 'index' ? false : true" class="rounded-lg px-4 text-sm font-bold cursor-pointer mr-8">
          <img alt="warloc logo" src="/warloc-icon.png" class="w-8 lg:w-8">
        </NuxtLink>
        <div class="flex items-center text-xs lg:text-sm">
          <NuxtLink replace to="/services" class="px-2 lg:px-6 py-3 font-bold cursor-pointer border-b-2 hover:border-b-2 border-transparent hover:border-secondary">
            SERVICES
          </NuxtLink>
          <NuxtLink replace to="/story" class="px-2 lg:px-6 py-3 font-bold cursor-pointer border-b-2 hover:border-b-2 border-transparent hover:border-secondary">
            STORY
          </NuxtLink>
          <NuxtLink replace to="/team" class="px-2 lg:px-6 py-3 font-bold cursor-pointer border-b-2 hover:border-b-2 border-transparent hover:border-secondary">
            TEAM
          </NuxtLink>
          <NuxtLink replace to="/about" class="px-2 lg:px-6 py-3 font-bold cursor-pointer border-b-2 hover:border-b-2 border-transparent hover:border-secondary">
            ABOUT
          </NuxtLink>
        </div>
      </div>
      <div class="grow w-full flex flex-col items-center justify-center text-6xl font-serif text-accent font-bold">
        <NuxtPage />
      </div>
      <div class="px-4 py-0 lg:py-9 text-xs flex flex-col md:flex-row w-full justify-between text-gray-600">
        <div class="flex items-center justify-center md:justify-start">
          Warloc &copy; 2025
        </div>
        <div class="flex items-center justify-center md:justify-start pt-2 pb-4 lg:py-0">
          <NuxtLink class="mx-4" href="https://warloc.app/terms-and-conditions" target="_blank">
            Terms & Conditions
          </NuxtLink>
          <NuxtLink class="mx-4" href="https://warloc.app/privacy-policy" target="_blank">
            Pivacy Policy
          </NuxtLink>
        </div>
      </div>
    </div>
    <div class="w-full lg:w-1/3 h-full bg-primary dark:text-white p-10">
      <div class="text-center lg:text-right">
        <NuxtLink href="https://warloc.app" class="rounded-lg px-4 py-2 text-sm font-bold border-2 border-white text-white">
          Go to App
        </NuxtLink>
      </div>
    </div>
  </div>
</template>
